<template>
  <b-nav vertical class="side-nav-content">
    <b-nav-item class="sidenav-item sidenav-item-heading border-bottom settings-heading">Settings</b-nav-item>
    <b-nav-item
      v-if="RoutePermission(false,'','invoice','settings','generalpreferences')"
      :to="{ name: 'UserTheme' }"
      class="sidenav-item border-bottom py-1"
      :class="{ active: active == 'UserTheme' }"
    >User Theme</b-nav-item>
    <b-nav-item
      v-if="RoutePermission(false, '', 'settings', 'settings', 'generalpreferences')"
      :to="{ name: 'Settings' }"
      class="sidenav-item border-bottom py-1"
      :class="{ active: active == 'Settings' }"
    >General</b-nav-item>

    <b-nav-item
      v-if="RoutePermission(false,'','invoice','settings','generalpreferences')"
      :to="{ name: 'CustomerStatement' }"
      class="sidenav-item border-bottom py-1"
      :class="{ active: active == 'CustomerStatement' }"
    >Customer</b-nav-item>
    <b-nav-item
      v-if="RoutePermission(false,'','invoice','settings','generalpreferences')"
      :to="{ name: 'ProductSettings' }"
      class="sidenav-item border-bottom py-1"
      :class="{ active: active == 'ProductSettings' }"
    >Product</b-nav-item>
    <b-nav-item
      v-if="RoutePermission(false,'','invoice','settings','generalpreferences')"
      class="head font-weight-bold sidenav-item bg-light border-bottom py-1"
      style="font-size:14px 1important"
      :class="{ active: active == 'InvoiceSettings' }"
    >Sales</b-nav-item>
    <b-nav-item
      v-if="RoutePermission(false,'','invoice','settings','generalpreferences')"
      :to="{ name: 'InvoiceSettings' }"
      class="sidenav-item border-bottom py-1"
      :class="{ active: active == 'InvoiceSettings' }"
    >Invoice</b-nav-item>
    <b-nav-item
      :to="{ name: 'QuotationSettings' }"
      class="sidenav-item border-bottom py-1"
      v-if="general_settings_details.preferences.modules.Sales&&RoutePermission(false,'','invoice','settings','generalpreferences')"
      :class="{ active: active == 'QuotationSettings' }"
    >Quotation</b-nav-item>
    <b-nav-item
      v-if="RoutePermission(false,'','invoice','settings','generalpreferences')"
      :to="{ name: 'CreditSettings' }"
      class="sidenav-item border-bottom py-1"
      :class="{ active: active == 'CreditSettings' }"
    >Credit</b-nav-item>
    <b-nav-item
      v-if="RoutePermission(false,'','invoice','settings','generalpreferences')"
      :to="{ name: 'CustomerAdvanceSettings' }"
      class="sidenav-item border-bottom py-1"
      :class="{ active: active == 'CustomerAdvanceSettings' }"
    >Customer Advance</b-nav-item>
    <b-nav-item
      v-if="RoutePermission(false,'','invoice','settings','generalpreferences')"
      :to="{ name: 'RetainerSettings' }"
      class="sidenav-item border-bottom py-1"
      :class="{ active: active == 'RetainerSettings' }"
    >Customer Deposit</b-nav-item>
    <b-nav-item
      v-if="RoutePermission(false,'','invoice','settings','generalpreferences')"
      :to="{ name: 'AmcSettings' }"
      class="sidenav-item border-bottom py-1"
      :class="{ active: active == 'AmcSettings' }"
    >AMC Contract</b-nav-item>
    <b-nav-item
      :to="{ name: 'PaymentSettings' }"
      class="sidenav-item border-bottom py-1"
      :class="{ active: active == 'PaymentSettings' }"
    >Payment Received</b-nav-item>
    <b-nav-item
      v-if="RoutePermission(false,'','invoice','settings','generalpreferences')"
      :to="{ name: 'RecurringSettings' }"
      class="mb-3 sidenav-item"
      :class="{ active: active == 'RecurringSettings' }"
    >Recurring Invoice</b-nav-item>
  </b-nav>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "SettingsLayout",
  props: ["active"],
  computed: {
    ...mapGetters(["general_settings_details"])
  }
};
</script>
